﻿import {
  AutoCompleteRenderType,
  AutoCompleteType,
  CarrierType,
  CustomerType,
  OfficeType,
  PhoneType,
  PickupType,
  ProspectType,
  ProType,
  ReferenceType,
  ShipmentMetadataType,
  TrackingType,
  UserType,
  VendorType,
} from '@components/Header/search/types';
import { FactoringCompanyType } from '@store/factoringCompany';

import { autoCompleteMap } from './constants';

/**
 * This function takes in an ambiguous item and calls the `targetFn` function
 * on the `AutoCompleteType<T>` object of the selected category.
 * @example
 * // This will call `autoCompleteMap[target].display(item);
 * assertAutoCompleteType(
 *   item,
 *   selectedCategory() as keyof typeof autoCompleteMap,
 *   'display',
 *  );
 * @param item
 * @param selectedCategory
 * @param targetFn
 * @returns
 */
export const assertAutoCompleteType = (
  item: AutoCompleteRenderType,
  selectedCategory: keyof typeof autoCompleteMap,
  targetFn: 'display' | 'redirect',
) => {
  const category = autoCompleteMap[selectedCategory];

  switch (selectedCategory) {
    case 'Ref #':
      return (category as AutoCompleteType<ReferenceType>)[targetFn](
        item as unknown as ReferenceType,
      );
    case 'Shipment Metadata':
      return (category as AutoCompleteType<ShipmentMetadataType>)[targetFn](
        item as unknown as ShipmentMetadataType,
      );
    case 'Carrier':
      return (category as AutoCompleteType<CarrierType>)[targetFn](
        item as unknown as CarrierType,
      );
    case 'Customer':
      return (category as AutoCompleteType<CustomerType>)[targetFn](
        item as unknown as CustomerType,
      );
    case 'Vendor':
      return (category as AutoCompleteType<VendorType>)[targetFn](
        item as unknown as VendorType,
      );
    case 'Prospect':
      return (category as AutoCompleteType<ProspectType>)[targetFn](
        item as unknown as ProspectType,
      );
    case 'Office':
      return (category as AutoCompleteType<OfficeType>)[targetFn](
        item as unknown as OfficeType,
      );
    case 'User':
      return (category as AutoCompleteType<UserType>)[targetFn](
        item as unknown as UserType,
      );
    case 'Tracking #':
      return (category as AutoCompleteType<TrackingType>)[targetFn](
        item as unknown as TrackingType,
      );
    case 'Factoring Company':
      return (category as AutoCompleteType<FactoringCompanyType>)[targetFn](
        item as unknown as FactoringCompanyType,
      );
    case 'Phone #':
      return (category as AutoCompleteType<PhoneType>)[targetFn](
        item as unknown as PhoneType,
      );
    case 'Pro #':
      return (category as AutoCompleteType<ProType>)[targetFn](
        item as unknown as ProType,
      );
    case 'Pickup #':
      return (category as AutoCompleteType<PickupType>)[targetFn](
        item as unknown as PickupType,
      );
  }
};
